"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[518],{

/***/ 7518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./lib/api.js
var api = __webpack_require__(4626);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(259);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 4 modules
var es = __webpack_require__(2512);
;// CONCATENATED MODULE: ./components/file-upload.jsx






var FileUpload = function(props) {
    var ref = (0,es/* useDropzone */.uI)({
        maxFiles: 5,
        accept: {
            "image/*": [],
            "application/msword": [],
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [],
            "application/pdf": [],
            "application/vnd.ms-powerpoint": [],
            "application/rtf": [],
            "text/*": [],
            "application/vnd.ms-excel": [],
            "application/vnd.openxmlformats-officedocument.presentationml.presentation": []
        },
        onDropAccepted: function(files) {
            props.setFileList((0,_define_property/* default */.Z)({}, props.recordField, files));
        }
    }), acceptedFiles = ref.acceptedFiles, getRootProps = ref.getRootProps, getInputProps = ref.getInputProps;
    // props.setFileList(acceptedFiles);
    var files = acceptedFiles.map(function(file) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            children: [
                file.path,
                " - ",
                (file.size / (1024 * 1024)).toFixed(2),
                " MB"
            ]
        }, file.path);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRootProps({
                className: "dropzone"
            })), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        id: props.recordField,
                        name: props.recordField
                    }, getInputProps())),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                className: "inline-block fill-gray-400",
                                id: "paperclip",
                                enableBackground: "new 0 0 511.895 511.895",
                                height: "32",
                                viewBox: "0 0 511.895 511.895",
                                width: "32",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "m476.804 45.673c-46.789-46.787-122.918-46.787-169.707 0l-276.393 276.393c-40.938 40.938-40.938 107.553 0 148.492 19.832 19.831 46.2 30.754 74.247 30.754s54.415-10.923 74.247-30.754l53.032-53.033 15.911 15.91c2.928 2.928 7.677 2.928 10.606 0l218.057-218.057c46.788-46.787 46.788-122.917 0-169.705zm-223.36 371.852-10.607-10.606 10.606-10.606 10.607 10.607zm212.753-212.754-191.54 191.541-10.607-10.607 191.54-191.539c35.091-35.092 35.091-92.188 0-127.28-35.092-35.089-92.188-35.091-127.279 0l-276.393 276.392c-29.242 29.243-29.242 76.824 0 106.067 29.244 29.242 76.822 29.242 106.066 0l218.058-218.058c23.393-23.394 23.393-61.459 0-84.853-11.333-11.332-26.4-17.573-42.427-17.573s-31.094 6.241-42.427 17.574c-2.929 2.929-2.929 7.678.001 10.606 2.928 2.928 7.677 2.929 10.606-.001 8.499-8.499 19.799-13.18 31.819-13.18s23.32 4.681 31.819 13.181c17.546 17.545 17.546 46.093 0 63.639l-218.056 218.058c-23.393 23.395-61.459 23.395-84.852 0-23.395-23.394-23.395-61.459 0-84.853l53.033-53.033 15.91 15.91c1.464 1.464 3.384 2.196 5.303 2.196s3.839-.732 5.304-2.196l138.507-138.507c2.929-2.93 2.929-7.678 0-10.607-2.93-2.928-7.678-2.928-10.607 0l-111.99 111.991-10.606-10.606 133.201-133.201c14.167-14.168 33.002-21.97 53.035-21.97s38.867 7.802 53.033 21.968c14.165 14.165 21.967 32.999 21.967 53.032 0 20.026-7.797 38.854-21.952 53.017l-218.072 218.072c-16.998 16.999-39.6 26.361-63.64 26.361s-46.642-9.362-63.64-26.36c-35.091-35.092-35.091-92.188 0-127.279l276.394-276.393c20.47-20.471 47.357-30.705 74.246-30.705s53.776 10.234 74.246 30.705c40.939 40.94 40.939 107.553 0 148.491zm-44.339 1.912c1.16-5.805 1.757-11.767 1.757-17.821 0-24.04-9.361-46.641-26.36-63.639-16.999-17-39.6-26.361-63.64-26.361-6.054 0-12.017.597-17.822 1.757l23.126-23.126c29.242-29.242 76.822-29.242 106.064 0 29.243 29.242 29.243 76.823 0 106.065zm-285.087 72.957 10.606 10.606-10.606 10.606-10.607-10.606z"
                                    })
                                })
                            }),
                            " ",
                            props.label,
                            props.required ? "*" : ""
                        ]
                    })
                ]
            })),
            files && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: files
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/form.jsx










function Form(props) {
    var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var ref = (0,react.useState)(false), messageSent = ref[0], setMessageSent = ref[1];
    var ref1 = (0,react.useState)({
        status: false,
        title: "",
        description: "",
        errors: null
    }), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)({}), fileList = ref2[0], setFileList = ref2[1];
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var captchaAvailable, data, gReCaptchaToken, _tmp, scoreResponse, scoreResult, formData, endpoint, response, result, err, notificationResponse, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        captchaAvailable = true;
                        if (!executeRecaptcha) {
                            captchaAvailable = false;
                            console.log("Execute recaptcha not yet available");
                        }
                        data = {
                            score: -1
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            15,
                            ,
                            16
                        ]);
                        if (!captchaAvailable) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            executeRecaptcha(props.dataLocation)
                        ];
                    case 2:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _tmp = null;
                        _state.label = 4;
                    case 4:
                        gReCaptchaToken = _tmp;
                        if (!gReCaptchaToken) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            fetch("/api/captcha", {
                                header: {
                                    "Content-Type": "application/json"
                                },
                                method: "post",
                                body: JSON.stringify({
                                    token: gReCaptchaToken
                                })
                            })
                        ];
                    case 5:
                        scoreResponse = _state.sent();
                        return [
                            4,
                            scoreResponse.json()
                        ];
                    case 6:
                        scoreResult = _state.sent();
                        if (scoreResult.score) {
                            data.score = scoreResult.score;
                            // console.log('score', data.score);
                            if (data.score < 0.5) {
                                setError({
                                    status: true,
                                    title: props.errorTitle,
                                    description: props.capchaErrorDescription,
                                    errors: null
                                });
                                setMessageSent(false);
                                return [
                                    2
                                ];
                            }
                        }
                        _state.label = 7;
                    case 7:
                        formData = new FormData();
                        Array.from(event.target.elements).forEach(function(_param) {
                            var name = _param.name, type = _param.type, value = _param.value, files = _param.files, element = (0,_object_without_properties/* default */.Z)(_param, [
                                "name",
                                "type",
                                "value",
                                "files"
                            ]);
                            if (![
                                "submit",
                                "file"
                            ].includes(type)) {
                                data[name] = value;
                            } else if (type === "file") {
                                Array.from(files).forEach(function(file) {
                                    formData.append("files.".concat(name), file, file.name);
                                });
                            }
                        });
                        Object.keys(fileList).forEach(function(key) {
                            Array.from(fileList[key]).forEach(function(f) {
                                formData.append("files.".concat(key), f, f.name);
                            });
                        });
                        formData.append("data", JSON.stringify(data));
                        endpoint = (0,api/* getApiURL */.t)("/api/".concat(props.dataLocation.toLowerCase(), "?populate=*"));
                        return [
                            4,
                            fetch(endpoint, {
                                method: "post",
                                body: formData
                            })
                        ];
                    case 8:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 9:
                        result = _state.sent();
                        if (!(response.status !== 200)) return [
                            3,
                            10
                        ];
                        err = {
                            status: true,
                            title: props.errorTitle,
                            description: props.incompleteDataErrorDescription,
                            errors: result.error.details.errors.map(function(e) {
                                return e.path[0];
                            })
                        };
                        setError(err);
                        setMessageSent(false);
                        return [
                            3,
                            14
                        ];
                    case 10:
                        if (!props.notificationTemplate) return [
                            3,
                            13
                        ];
                        return [
                            4,
                            fetch("/api/notification", {
                                header: {
                                    "Content-Type": "application/json"
                                },
                                method: "post",
                                body: JSON.stringify({
                                    notificationTemplate: props.notificationTemplate,
                                    notificationEmail: props.notificationEmail,
                                    target: props.dataLocation,
                                    data: result.data.attributes
                                })
                            })
                        ];
                    case 11:
                        notificationResponse = _state.sent();
                        return [
                            4,
                            notificationResponse.json()
                        ];
                    case 12:
                        _state.sent();
                        _state.label = 13;
                    case 13:
                        setError({
                            status: false
                        });
                        setMessageSent(true);
                        _state.label = 14;
                    case 14:
                        return [
                            3,
                            16
                        ];
                    case 15:
                        e = _state.sent();
                        console.log(e);
                        return [
                            3,
                            16
                        ];
                    case 16:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        props,
        executeRecaptcha,
        fileList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:w-2/3 xl:w-2/3  md:mx-auto ".concat(props.formCssClasses ? props.formCssClasses : "bg-white rounded-xl  shadow-lg mx-4 p-10 md:p-20 md:px-30"),
            children: [
                error.status && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full text-center px-20 pb-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-action",
                            children: error.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "".concat(props.descriptionCssClasses ? props.descriptionCssClasses : "py-4"),
                            children: error.description
                        })
                    ]
                }, "err"),
                messageSent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full text-center px-20 pb-4",
                    children: [
                        props.confirmationTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            id: "success-title-".concat(props.dataLocation.toLowerCase()),
                            className: "text-trust tag-success",
                            children: props.confirmationTitle
                        }),
                        props.confirmationDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "py-4",
                            children: props.confirmationDescription
                        }),
                        props.confirmationButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            id: "resubmit-form",
                            onClick: function() {
                                return setMessageSent(false);
                            },
                            className: "btn btn-md ".concat(props.confirmationButton.style),
                            children: props.confirmationButton.label
                        })
                    ]
                }),
                !messageSent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !error.status && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full text-center px-0 md:px-20 pb-4",
                            children: [
                                props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "".concat(props.titleCssClasses ? props.titleCssClasses : "text-action text-4xl"),
                                    children: props.title
                                }),
                                props.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: props.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            // encType="multipart/form-data"
                            onSubmit: handleSubmit,
                            action: "",
                            className: "space-y-4 md:space-y-8 items-left",
                            children: [
                                props.fields.map(function(f) {
                                    if (f.fieldType === "input.text" || f.fieldType === "input.email" || f.fieldType === "input.date" || f.fieldType === "input.time" || f.fieldType === "input.number") {
                                        var ref;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-full md:w-1/2 inline-block p-3 text-left",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: "text-[8px] uppercase justify-start",
                                                    htmlFor: f.recordField,
                                                    children: [
                                                        f.label,
                                                        f.required ? "*" : ""
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: f.fieldType.replace("input.", ""),
                                                    id: f.recordField,
                                                    name: f.recordField,
                                                    className: "shadow-sm border rounded-[0.25rem] placeholder:uppercase placeholder:text-xs placeholder:font-semibold focus:ring-primary-500 focus:border-primary-500 block w-full p-3 ".concat(((ref = error.errors) === null || ref === void 0 ? void 0 : ref.includes(f.recordField)) ? "border-action bg-red-100" : "border-maturity-100"),
                                                    required: f.required,
                                                    placeholder: "".concat(f.label).concat(f.required ? "*" : "")
                                                })
                                            ]
                                        }, f.id);
                                    }
                                    if (f.fieldType === "input.hidden") {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            id: f.recordField,
                                            name: f.recordField,
                                            value: f.defaultValue,
                                            required: f.required
                                        }, f.id);
                                    }
                                    if (f.fieldType === "dropdown") {
                                        var ref1;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "ww-full md:w-1/2 inline-block p-3 text-left",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: "text-[8px] uppercase justify-start",
                                                    htmlFor: f.recordField,
                                                    children: [
                                                        f.recordField,
                                                        f.required ? "*" : ""
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                    id: f.recordField,
                                                    name: f.recordField,
                                                    className: "shadow-sm  border  rounded-[0.25rem] placeholder:uppercase placeholder:text-xs placeholder:font-semibold focus:ring-primary-500 focus:border-primary-500 block w-full p-3 ".concat(((ref1 = error.errors) === null || ref1 === void 0 ? void 0 : ref1.includes(f.recordField)) ? "border-action bg-red-100" : "border-maturity-100"),
                                                    required: f.required,
                                                    placeholder: "".concat(f.label).concat(f.required ? "*" : ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "",
                                                            disabled: true,
                                                            defaultValue: true,
                                                            children: "".concat(f.label).concat(f.required ? "*" : "")
                                                        }),
                                                        f.options.map(function(opt) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: opt.label,
                                                                children: opt.label
                                                            }, opt.id);
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, f.id);
                                    }
                                    if (f.fieldType === "file" || f.fieldType === "files") {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full p-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileUpload, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, f), {
                                                    setFileList: setFileList
                                                }))
                                            }, f.id)
                                        });
                                    }
                                    if (f.fieldType === "textarea") {
                                        var ref2;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-full p-3 text-left",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: "text-[8px] uppercase justify-start",
                                                    htmlFor: f.recordField,
                                                    children: [
                                                        f.recordField,
                                                        f.required ? "*" : ""
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    id: f.recordField,
                                                    name: f.recordField,
                                                    rows: "6",
                                                    className: "shadow-sm border rounded-[0.25rem] placeholder:uppercase placeholder:text-xs placeholder:font-semibold focus:ring-primary-500 focus:border-primary-500 block w-full p-3 ".concat(((ref2 = error.errors) === null || ref2 === void 0 ? void 0 : ref2.includes(f.recordField)) ? "border-action bg-red-100" : "border-maturity-100"),
                                                    required: f.required,
                                                    placeholder: "".concat(f.label).concat(f.required ? "*" : "")
                                                })
                                            ]
                                        }, f.id);
                                    }
                                }),
                                props.submitButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full p-3 text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        id: "submit-form",
                                        type: "submit",
                                        className: "btn btn-md ".concat(props.submitButton.style),
                                        children: props.submitButton.label
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    id: "submit-form",
                                    type: "submit",
                                    className: "btn btn-md action-full ",
                                    children: "Send message"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ })

}]);